import React, { forwardRef, memo } from 'react'

const IdCardIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="185.5"
      height="108.5"
      viewBox="0 0 265 155"
      fill="none"
      {...props}>
      <rect width="265" height="155" rx="20" fill="#78BE20" />
      <circle cx="55" cy="63" r="34" fill="white" />
      <circle cx="55" cy="53.158" r="10.105" fill="#CEDC00" />
      <path
        d="M71 80.9473C71 76.7038 69.3143 72.6341 66.3137 69.6336C63.3131 66.633 59.2435 64.9473 55 64.9473C50.7565 64.9473 46.6869 66.633 43.6863 69.6336C40.6857 72.6341 39 76.7038 39 80.9473L55 80.9473H71Z"
        fill="#CEDC00"
      />
      <rect x="103" y="29" width="145" height="43" rx="12" fill="#CEDC00" />
      <rect x="103" y="78" width="55" height="29" rx="12" fill="#CEDC00" />
      <rect x="103" y="117" width="145" height="22" rx="11" fill="#CEDC00" />
      <rect x="164" y="78" width="84" height="29" rx="12" fill="#CEDC00" />
    </svg>
  )
)

IdCardIcon.displayName = 'IdCardIcon'

export default memo(IdCardIcon)
